<template>
  <div
    id="sidebar"
    class="sidebar"
    :class="{ minimized: value }"
    :style="sidebarStyle"
    :data-color="backgroundColor"
    :data-image="backgroundImage"
  >
    <div style="height: 50px"></div>

    <div class="sidebar-wrapper">
      <div class="logo">
        <div class="d-flex toggle-wrapper">
          <transition @enter="enter" @leave="leave">
            <div v-if="!value" class="">Dashboard</div>
          </transition>

          <div class="arrow-wrapper" @click="hideSidebar">
            <svg
              class="arrow"
              width="8"
              height="10"
              viewBox="0 0 8 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 10L1 5.5L7 1"
                stroke="currentColor"
                stroke-linecap="round"
              />
            </svg>
            <svg
              class="arrow"
              width="8"
              height="10"
              viewBox="0 0 8 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 10L1 5.5L7 1"
                stroke="currentColor"
                stroke-linecap="round"
              />
            </svg>
          </div>
        </div>
      </div>

      <slot name="content"></slot>
      <ul class="nav nav-main__links">
        <!-- By default vue-router adds an active class to each route link. This way the links are colored when clicked -->
        <slot>
          <sidebar-link
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :to="link.path"
            @click="closeNavbar"
            :link="link"
          >
            <i :class="link.icon"></i>
            <p>{{ link.name }}</p>
          </sidebar-link>
        </slot>
      </ul>
      <ul class="nav nav-bottom" v-if="$slots['bottom-links']">
        <slot name="bottom-links"></slot>
      </ul>
    </div>
  </div>
</template>
<script>
import SidebarLink from "./SidebarLink.vue";

import transitionFunctionConstructor from "../../mixins/transitionFunctionConstructor";

export default {
  mixins: [transitionFunctionConstructor("enter", "leave", "width")],
  components: {
    SidebarLink,
  },
  props: {
    value: Boolean,
    title: {
      type: String,
      default: "Vue LBD",
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: (value) => {
        let acceptedValues = [
          "",
          "blue",
          "azure",
          "green",
          "orange",
          "red",
          "purple",
          "black",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    backgroundImage: {
      type: String,
      default: "/img/sidebar-5.jpg",
    },
    activeColor: {
      type: String,
      default: "success",
      validator: (value) => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundColor: "",
      };
    },
  },
  methods: {
    hideSidebar() {
      if (window.screen.width > 1024) {
        this.$emit("input", !this.value);
      } else if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
<style scoped>
#sidebar {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    rgba(0, 0, 0, 0.85) !important;
}

#sidebar {
  overflow: auto;
}

#sidebar .sidebar-wrapper {
  display: flex;
  flex-direction: column;
  transition-duration: 0.15s;
  overflow: auto;
}

#sidebar .nav-main__links {
  flex: 1;
}

#sidebar .sidebar-wrapper .logo .logo__container {
  padding-left: 10px;
}

.logo-img {
  width: 100%;
  height: auto;
}

img.arrow {
  margin-left: 10px;
}

img.arrow + img.arrow {
  margin-left: 0;
}

.flex {
  display: flex;
}

.flex-item {
  flex: calc(1 / 4);
}

.toggle-wrapper {
  height: 16px;
  position: relative;
  transition-duration: 0.15s;
}

.arrow-wrapper {
  display: block;
  cursor: pointer;
  position: absolute;
  margin-left: 0px;
  width: 16px;
  right: 0;
  top: 50%;
  margin-left: 0px;
  transform: translate(0px, -50%) rotate(0deg);
  transition-duration: 0.15s;
}

.arrow-wrapper:hover .arrow {
  color: #33c9d2;
}

.minimized .arrow-wrapper {
  transform: translateY(-50%) rotate(180deg);
  margin-left: -8px;
}

.minimized,
.minimized .sidebar-wrapper {
  width: 50px !important;
}

@media (max-width: 991px) {
  .logo {
    margin-top: 12px;
  }

  .arrow-wrapper {
    opacity: 0;
    visibility: hidden;
  }

  .nav-main__links {
    margin-bottom: 300px;
  }
}

@media (max-width: 650px) {
  #sidebar {
    width: 100% !important;
    left: -100%;
  }
  #sidebar .sidebar-wrapper {
    width: 100% !important;
  }
  .nav-open #sidebar {
    left: 0;
  }
}
</style>
